import { useState, useEffect } from 'react';
import useDataBean from '../../../../core/services/dataBean/useDataBean';
import { toast } from 'react-toastify';
import Select from 'react-select';
import { _Project } from '../../../../core/services/dataBean/EntityCatalogVdos';
import { _single } from '../../../../core/services/dataBean/EntityCatalog';

interface Props {
    idSelector: number;
    onChange: any;
    label?: string;
    returnType?: "ID" | "Object";
    disabled?: boolean;
}

export const SelectProject = ({ idSelector, onChange, label, returnType = "ID", disabled }: Props) => {
    const { instance, setLista, lista } = useDataBean(_Project);
    const [selectedOption, setSelectedOption] = useState<any>(null);

    useEffect(() => {
        getLista();
    }, []);

    useEffect(() => {
        if (idSelector && lista.length > 0) {
            const found = lista.find(item => item.DataBeanProperties.IDProject === idSelector);
            if (found) {
                setSelectedOption({
                    value: found.DataBeanProperties.IDProject,
                    label: `${found.DataBeanProperties.Name}`,
                    item: found
                });
            }
        }
    }, [idSelector, lista]);

    const getLista = () => {


        instance.getProjectCatalogPorPropiedadesRender({ State: 1 }, null).then((resp: any) => {
            if (resp) {

                setLista(resp);
            }

        }).catch(err => toast.error(err));



        // instance.getProjectRender(null, null, { State: 1 }).then((resp: any) => {
        //     if (resp.List) setLista(resp.List);
        //     console.log(resp)
        // }).catch(err => toast.error(err));
    };

    const handleChange = (option: any) => {
        setSelectedOption(option);
        if (!option) {
            if (onChange)
                onChange(returnType === "Object" ? null : null);
        } else {

            if (onChange) {
                onChange(returnType === "Object" ? option.item.DataBeanProperties : option.value);
            }
        }
    };

    const options = lista.map((item: any) => ({
        value: item.DataBeanProperties.IDProject,
        label: `${item.DataBeanProperties.Name}`,
        item: item
    }));

    return (
        <div>
            {label && label != " " &&
                < label > {label ?? "Proyecto"}</label>
            }
            <Select
                options={options}
                value={selectedOption}
                onChange={handleChange}
                isClearable
                placeholder="Selecciona un proyecto..."
                noOptionsMessage={() => "Sin coincidencias"}
                isDisabled={disabled}
                menuPortalTarget={document.body}
                menuPosition="fixed"
                styles={{
                    menuPortal: base => ({ ...base, zIndex: 1100 })
                }}
            />
        </div >
    );
};
